var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_529_83169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.87,
    d: "M16 0C24.84 0 32 7.16 32 16C32 24.84 24.84 32 16 32C7.16 32 0 24.84 0 16C0 7.16 7.16 0 16 0Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.9451 11.76C27.5251 8.65999 25.0551 6.18999 21.9451 5.74999C21.6051 5.69999 21.2551 5.67999 20.9151 5.67999C19.0751 5.67999 17.3151 6.38999 16.0051 7.63999C14.6951 6.38999 12.9351 5.67999 11.0951 5.67999C10.8651 5.67999 10.6351 5.68999 10.4151 5.70999C7.0451 6.02999 4.2951 8.79999 4.0351 12.15C3.9251 13.58 4.2351 14.98 4.9351 16.2C5.0451 16.41 5.1851 16.6 5.3551 16.8L6.3351 17.92L6.4551 18.05L14.5751 25.75C14.9651 26.12 15.4751 26.32 16.0051 26.32C16.5351 26.32 17.0551 26.12 17.4351 25.75L25.5951 18L25.6351 17.96L26.7351 16.7L26.7951 16.64L26.8751 16.52C26.9351 16.44 27.0051 16.32 27.0651 16.2C27.8351 14.85 28.1351 13.31 27.9251 11.75L27.9451 11.76Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.75 7.03998C19.33 6.69998 17.15 7.83998 15.99 9.67998C14.88 7.90998 12.82 6.78998 10.52 6.99998C7.75001 7.25998 5.53001 9.49998 5.31001 12.25C5.21001 13.46 5.49001 14.6 6.05001 15.56C6.12001 15.7 6.22001 15.82 6.32001 15.94L7.28001 17.05L7.36001 17.14L15.44 24.81C15.74 25.1 16.22 25.1 16.52 24.81L24.66 17.08L25.76 15.81C25.81 15.72 25.86 15.64 25.91 15.56C26.51 14.51 26.79 13.25 26.61 11.93C26.27 9.41998 24.25 7.38998 21.72 7.03998H21.75Z",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M11.0098 8.6C13.1098 8.57 14.9698 9.66 15.9998 11.3C17.0298 9.66 18.8698 8.58 20.9598 8.6C23.8198 8.62 26.2398 10.78 26.6398 13.53C26.6898 13.2 26.7098 12.87 26.6998 12.53C26.5998 9.48 24.0398 6.99999 20.9598 6.96999C18.8698 6.94999 17.0298 8.04 15.9998 9.67C14.9598 8.03 13.1098 6.93999 11.0098 6.96999C7.93981 7.00999 5.38981 9.5 5.30981 12.54C5.30981 12.88 5.31981 13.21 5.36981 13.53C5.76981 10.78 8.16981 8.63 11.0198 8.59L11.0098 8.6Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_83169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeart);
export default __webpack_public_path__ + "static/media/LikeHeart.39ebe65e6ab36a61c74c28db77f108d0.svg";
export { ForwardRef as ReactComponent };